<div class="d-flex flex-center border p-1 rounded gap-4">

<button
        ngxTippy="List View"
        (click)="activateListView()"
        [class.opacity-50]="!isListView"
        class="btn btn-icon btn-light btn-sm"
      >
        <i class="ki-duotone ki-row-horizontal">
          <i class="path1"></i>
          <i class="path2"></i>
        </i>
      </button>
      <button
        ngxTippy="Grid View"
        (click)="activateGridView()"
        [class.opacity-50]="!!isListView"
        class="btn btn-icon btn-light btn-sm"
      >
        <i class="ki-duotone ki-element-11">
          <i class="path1"></i>
          <i class="path2"></i>
          <i class="path3"></i>
          <i class="path4"></i>
        </i>
      </button>
    </div>
